// Barcode plugin used by this directive: https://github.com/lindell/JsBarcode

module.exports = /* @ngInject */
() => {
    return {
        scope: {
            barcodeGenerator: '='
        },
        link($scope, $element, attrs) {
            $scope.$watch('barcodeGenerator', (newValue, oldValue) => {
                if ($scope.barcodeGenerator) {
                    // eslint-disable-next-line babel/new-cap
                    $element.JsBarcode($scope.barcodeGenerator, {
                        width: 2,
                        format: 'CODE128'
                    });
                }
            });
        }
    };
};
